const university = [
	{
		res: `Domain coordinator for the honors course “ Artificial Intelligence & Machine Learning”`,
	},
	{
		res: `Worked as Team Leader & Coordinator in framing the syllabus of Discrete Mathematics 
		2019 course`,
	},
	{
		res: `Chairman for the subjects Discrete Mathematics ( 2019 course)`,
	},
	{
		res: `Chairman for the subjects Discrete Structure( 2012 & 2015 Course)
		`,
	},
	{
		res: `Chairman for the subjects Advance Databases (2008 & 2012 Course)`,
	},
	{
		res: `Paper setter for the different subjects ( ADB, DS, CG, SDMT)`,
	},
	{
		res: `Online question bank preparation ( DS & CG)
		`,
	},
	{
		res: `Syllabus setting & discussion panel ( STQA, DS, SDMT, CG)`,
	},
	{
		res: `Paper evaluation`,
	},
	{
		res: `Paper revaluation`,
	},
	{
		res: `. Sr. Supervisor`,
	},
	{
		res: `Paper setter in the panel of North Maharastra University(N.M.U), Jalgaon`,
	},
];

const college = [
	{
		res: `Started Virtual Lab (MHRD & IIT Bombay initiative) nodal centre`,
	},
	{
		res: `Worked as a Dean (Second Shift)`,
	},
	{
		res: `Student Council Coordinator`,
	},
	{
		res: `Campus Wi-Fi Coordinator
		`,
	},
	{
		res: `Sr. Supervisor in SPPU Exam`,
	},
	{
		res: `Spoken Tutorial ( MHRD & IIT Bombay Initiative) Coordinator`,
	},
];

const department = [
	{
		res: `Signed and effectively executed many MoU with Industries`,
	},
	{
		res: `Worked as Head of department ( Handled NAAC & NBA)
		`,
	},
	{
		res: `Worked as Head (Second Shift) Computer Engineering
		`,
	},
	{
		res: `Industry Institute Interaction(I-I-I) Cell Coordinator`,
	},
	{
		res: `NAAC Coordinator`,
	},
	{
		res: `FDP/ Workshop/ Guest Lecture/ Seminar Coordinator`,
	},
	{
		res: `Department Technical Activities Coordinator`,
	},
	{
		res: `Project Coordinator`,
	},
	{
		res: `Student Association Coordinator`,
	},
];
const data = { university, college, department };
export default data;
